export default __webpack_public_path__ + "static/media/failed.62d21931.svg";